import React from 'react';
import Nav       from './components/Nav';
import Hero      from './components/Hero';
import Proof     from './components/Proof';
import Features  from './components/Features';
import Audience  from './components/Audience';
import Countries from './components/Countries';
import Pricing   from './components/Pricing';
import About     from './components/About';
import Contact   from './components/Contact';
import Footer    from './components/Footer';

export default function App() {
  return (
    <>
      <Nav/>
      <main>
        <Hero/>
        <Proof/>
        <Features/>
        <Audience/>
        <Countries/>
        <Pricing/>
        <About/>
        <Contact/>
      </main>
      <Footer/>
    </>
  );
}
